import { AccordionIcon } from './'
import { InputTasa, InputSubTasa, FormLabel, FormError } from '../../../components/common'
import { OPERATION_MODE } from '@laramie/ui';
import { useEffect } from 'react'

const TasasPlan = ({ toggle, open, formValues, handleInputProxy, errorOf, params }) => {
    return <>
        <div className='accordion-header m-top-20'>
            <div className='row'>
                <div className="col-12" onClick={toggle}>
                    <div className='accordion-header-title'>
                        <AccordionIcon open={open} />
                        <h3 className={open ? 'active' : ''}>Tasas del plan de pago</h3>
                    </div>
                </div>
            </div>
        </div>
        {open && (
            <div className='accordion-body'>
                <div className='row form-basic'>

                    <div className="col-12 col-md-6 col-lg-3">
                        <FormLabel htmlFor="idTasaPlanPago" required>Tasa del plan de pago</FormLabel>
                        <InputTasa
                            name="idTasaPlanPago"
                            placeholder=""
                            className={`form-control ${errorOf('idTasaPlanPago') ? 'is-invalid' : ''}`}
                            value={formValues.idTasaPlanPago}
                            onChange={handleInputProxy}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                            hideLoading
                            soloPlanes={true}
                        />
                        <FormError message={errorOf('idTasaPlanPago')} />
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <FormLabel htmlFor="idSubTasaPlanPago" required>Sub tasa del plan de pago</FormLabel>
                        <InputSubTasa
                            name="idSubTasaPlanPago"
                            placeholder=""
                            className={`form-control ${errorOf('idSubTasaPlanPago') ? 'is-invalid' : ''}`}
                            value={formValues.idSubTasaPlanPago}
                            onChange={handleInputProxy}
                            idTasa={formValues.idTasaPlanPago}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                            hideLoading
                        />
                        <FormError message={errorOf('idSubTasaPlanPago')} />
                    </div>
                </div>
            </div>
        )}
    </>
}

export default TasasPlan
